$(function() {
  //kod
  var settings = {};
  $.fn.stickyElement = function(method, options, parent_container_class) {
    var that = $(this);
    // $('.element').stickyElement('work', {
    //   'elementOffset': 0.7, //if element is top: 0, leave 0 or remove it.
    // }, '.section--offset'); //sticky container class

    if (that.length && method == 'work') {
      settings = $.extend({
        element: $(this), //element that has to stick
        elementOffset: 0,
        container: $(parent_container_class), //container to which element have to stick
        containerHeight: $(this).closest(parent_container_class).outerHeight(), //container to which element have to stick
        scrollTop: $(window).scrollTop(),
        winHeight: $(window).outerHeight(true),
        additional_offset: Math.round($(parent_container_class).offset().top)
      }, options);
    }

    //this setting is required if elements position is not top: 0;
    //if element is 50%/50vh from top of the container or screen(fixed) --- offset = 0.5 * $(window).innerHeight();
    
    // if (vh or %) {}
    // else if (px) {}
    if (settings.elementOffset && settings.elementOffset != 0 && settings.elementOffset <= 1) {
      settings.offset = $(window).innerHeight() * settings.elementOffset;
    } else if (settings.elementOffset && settings.elementOffset != 0 && settings.elementOffset > 1) {
      settings.offset = settings.elementOffset;
    }

    var methods = {
      destroy: function() {
        $(settings.element).css('position', '').css('bottom', '').css('top', '');
        settings.destroy = true;
      },
      update: function() {
        settings.winHeight = $(window).outerHeight(true);
        settings.scrollTop = $(window).scrollTop();
        settings.containerHeight = settings.container.outerHeight();
        settings.additional_offset = settings.container.offset().top
        if (settings.elementOffset && settings.elementOffset != 0 && settings.elementOffset <= 1) {
          settings.offset = $(window).innerHeight() * settings.elementOffset;
        } else if (settings.elementOffset && settings.elementOffset != 0 && settings.elementOffset > 1) {
          settings.offset = settings.elementOffset;
        }
      },
      work: function() {
        if (typeof settings.destroy === 'undefined' || settings.destroy === false || settings.destroy === undefined) {
          if (settings.offset && settings.offset !== 0) {
            if (settings.scrollTop >= settings.additional_offset && settings.scrollTop < settings.containerHeight + settings.additional_offset - $(settings.element).outerHeight(true) - settings.offset) {
              $(settings.element).css('position', 'fixed').css('bottom', 'auto').css('top', settings.offset);
            } else if (settings.scrollTop + $(settings.element).outerHeight(true) + settings.offset >= settings.containerHeight + settings.additional_offset) {
              $(settings.element).css('position', 'absolute').css('bottom', '0').css('top', 'auto');
            } else if (settings.scrollTop < settings.additional_offset) {
              $(settings.element).css('position', '').css('bottom', '').css('top', '');
            }
          } else {
            if (settings.scrollTop >= settings.additional_offset && settings.scrollTop < settings.containerHeight + settings.additional_offset - $(settings.element).outerHeight(true)) {
              $(settings.element).css('position', 'fixed').css('bottom', 'auto').css('top', '0');
            } else if (settings.scrollTop + $(settings.element).outerHeight(true) >= settings.containerHeight + settings.additional_offset) {
              $(settings.element).css('position', 'absolute').css('bottom', '0').css('top', 'auto');
            } else if (settings.scrollTop < settings.additional_offset) {
              $(settings.element).css('position', '').css('bottom', '').css('top', '');
            }
          }
          requestAnimationFrame(methods.work);
        }
      }
    };

    //update settings
    $(window).on('resize', function() {
      if (that.length) {
        settings.winHeight = $(window).outerHeight(true);
        settings.scrollTop = $(window).scrollTop();
        settings.containerHeight = settings.container.outerHeight();
        settings.additional_offset = settings.container.offset().top
        if (settings.elementOffset && settings.elementOffset != 0) {
          settings.offset = $(window).innerHeight() * settings.elementOffset;
        }
        if (typeof interval == undefined || interval === undefined) {
          var interval = setInterval(function() {
            settings.additional_offset = settings.container.offset().top
          }, 1000);
        } else {
          clearInterval(interval);
        }
        setTimeout(function() {
          clearInterval(interval);
          interval = false;
        }, 8000);
      }
    });

    //update settings
    $(window).on('scroll', function() {
      if (that.length) {
        settings.scrollTop = $(window).scrollTop();
      }
    });

    //run
    return this.each(function() {
      $this = $(this);
      if (methods[method]) {
        return methods[method].apply(this);
      }
    });
  };

}(jQuery));